<template>
    <el-dialog v-model="visible" title="加入题单" width="450px" append-to-body>
        <div v-loading="loading">
            <el-radio-group v-model="selectedListId" class="list-selection">

                <!-- 个人题单（题库） -->
                <div class="list-section" v-if="defaultLists.length">
                    <div class="section-title">个人题单（题库）</div>
                    <el-radio v-for="list in defaultLists" :key="list.id" :label="list.id" border
                        class="list-radio default-list">
                        <div class="list-info">
                            <span class="list-title"><i class="fas fa-layer-group"
                                    style="color:#409EFF; margin-right:6px;"></i>{{ list.title }}</span>
                            <span class="list-count">({{ list.questions?.length || 0 }} 题)</span>
                        </div>
                    </el-radio>
                </div>

                <el-divider v-if="defaultLists.length && customLists.length" style="margin: 10px 0;"></el-divider>

                <!-- 自己创建的题单 -->
                <div class="list-section">
                    <div class="section-title">自己创建的题单</div>
                    <el-radio v-for="list in customLists" :key="list.id" :label="list.id" border class="list-radio">
                        <div class="list-info">
                            <span class="list-title">{{ list.title }}</span>
                            <span class="list-count">({{ list.questions?.length || 0 }} 题)</span>
                        </div>
                    </el-radio>

                    <el-empty v-if="customLists.length === 0 && !loading" description="暂无自定义题单，先去创建一个吧"
                        :image-size="60">
                        <el-button type="primary" link size="small"
                            @click="$router.push('/question-lists')">去创建</el-button>
                    </el-empty>
                </div>

            </el-radio-group>
        </div>

        <template #footer>
            <el-button @click="visible = false">取消</el-button>
            <el-button type="primary" :disabled="!selectedListId" :loading="saving" @click="handleConfirm">
                确定加入
            </el-button>
        </template>
    </el-dialog>
</template>

<script setup>
import { ref, watch, computed } from 'vue'
import { ElMessage } from 'element-plus'
import api from '@/utils/api'

const props = defineProps({
    modelValue: Boolean,
    questionId: [Number, String]
})
const emit = defineEmits(['update:modelValue', 'success'])

const visible = ref(false)
const loading = ref(false)
const saving = ref(false)
const lists = ref([])
const selectedListId = ref(null)

const defaultLists = computed(() => lists.value.filter(l => l.isDefault))
const customLists = computed(() => lists.value.filter(l => !l.isDefault))

watch(() => props.modelValue, (val) => {
    visible.value = val
    if (val) {
        selectedListId.value = null
        fetchMyLists()
    }
})

watch(visible, (val) => {
    emit('update:modelValue', val)
})

const fetchMyLists = async () => {
    loading.value = true
    try {
        const res = await api.get('/api/question-lists', { params: { type: 'mine' } })
        lists.value = res.data.lists || []
    } catch (err) {
        ElMessage.error('加载题单失败')
    } finally {
        loading.value = false
    }
}

const handleConfirm = async () => {
    if (!selectedListId.value) return
    saving.value = true
    try {
        await api.post(`/api/question-lists/${selectedListId.value}/questions`, {
            questionIds: [parseInt(props.questionId)]
        })
        ElMessage.success('已加入题单')
        visible.value = false
        emit('success')
    } catch (err) {
        ElMessage.error('加入失败')
    } finally {
        saving.value = false
    }
}
</script>

<style scoped>
.list-selection {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
}

.list-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
}

.section-title {
    font-size: 13px;
    font-weight: bold;
    color: #606266;
    margin-bottom: 4px;
    padding-left: 4px;
}

.list-radio {
    width: 100%;
    margin-right: 0 !important;
    height: auto !important;
    padding: 12px !important;
    border-radius: 6px;
}

.default-list {
    background-color: #f4f9ff;
    border-color: #c6e2ff;
}

.default-list.is-bordered.is-checked {
    border-color: #409EFF;
}

.list-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.list-title {
    font-weight: 500;
    color: #303133;
    display: flex;
    align-items: center;
}

.list-count {
    font-size: 12px;
    color: #909399;
}
</style>
